import { LayerList, LayerType } from "../editor/models/layer.model"
import { buildNewLayer } from "../editor/store/editor.utils"

export function constructBlankRender() {
  const layer = buildNewLayer(LayerType.Base)
  const layerList: LayerList = {
    [layer.id]: layer
  }
  const layerOrder = [layer.id]
  return {layers: layerList, layerOrder}
}
